import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@chakra-ui/react';
import { BOOKING_CHANNEL, GET_SEARCH_RULES_QUERY, SITE_LEISURE, Channel, FT_PI_GROUP_BOOKING_FORM, FT_PI_DISCOUNT_RATE, FT_PI_BB_CCUI_BARRIER_FREE_LABEL, getStaticContent, CountryCode, PageName } from '@whitbread-eos/api';
import { SearchSummary } from '@whitbread-eos/atoms';
import { Search, SearchPriceFinder, STAY_DETAILS_STATE_INITIAL_VALUE, SEARCH_REFERRER_INITIAL_VALUE, DISTANCE_FROM_SEARCH_INITIAL_VALUE } from '@whitbread-eos/molecules';
import { useQueryRequest, useScreenSize, swapKeysAndValues, ternaryCondition, logicalAndOperator, useCustomLocale, useLocalStorage, getMappedRooms, useFeatureToggle } from '@whitbread-eos/utils';
import { add, isValid } from 'date-fns';
import { de, enGB } from 'date-fns/locale';
import debounce from 'lodash/debounce';
import { useTranslation } from 'next-i18next';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { getSearchStyles, getSearchPriceFinderStyles } from '../styles/pi.style';
import { getRoomsPlaceholder, singleHotelSearchBB } from '../utilities';
import { formatSummaryDateRange, setSearchLocationInLocalStorage, mapSearchParamsForURL, ERROR_KEYS, FIELDS, ERROR_FIELDS } from '../utilities/searchContainerHelpers';
import { validateSearchData } from '../validations/searchValidation';
import { useOfferDetection } from './useOfferDetection';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var MIN_LENGTH_SEARCH_TERM = 3;
export default function SearchContainer(_ref) {
  var _maxNightsLimitation, _dataTranslations$hea, _dataTranslations$hea2, _dataTranslations$hea3, _partialTranslations$, _globalConfig, _maxNightsLimitation2, _matchedOffer$maxRoom, _matchedOffer$numberO, _maxArrivalDateLimita, _partialTranslations$2, _dataTranslations$hea4, _dataTranslations$hea5, _dataTranslations$hea6, _dataTranslations$hea7, _dataTranslations$hea8, _partialTranslations$3, _partialTranslations$6, _partialTranslations$7, _partialTranslations$8, _partialTranslations$9, _partialTranslations$0, _partialTranslations$1;
  var searchLocation = _ref.searchLocation,
    defaultLocation = _ref.defaultLocation,
    defaultRooms = _ref.defaultRooms,
    ARRdd = _ref.ARRdd,
    ARRmm = _ref.ARRmm,
    ROOMS = _ref.ROOMS,
    ARRyyyy = _ref.ARRyyyy,
    NIGHTS = _ref.NIGHTS,
    CORPID = _ref.CORPID,
    _ref$isSummaryActive = _ref.isSummaryActive,
    isSummaryActive = _ref$isSummaryActive === void 0 ? Boolean(ARRyyyy && ARRmm && ARRdd) : _ref$isSummaryActive,
    variant = _ref.variant,
    marginBottom = _ref.marginBottom,
    handleLocationSearch = _ref.handleLocationSearch,
    setLocationName = _ref.setLocationName,
    PROMOID = _ref.PROMOID,
    pageName = _ref.pageName,
    disableFlip = _ref.disableFlip;
  var initialData = {
    managedPlaces: [],
    places: [],
    properties: []
  };
  var _useFeatureToggle = useFeatureToggle(),
    isPIGroupBookingFormEnabled = _useFeatureToggle[FT_PI_GROUP_BOOKING_FORM],
    isDiscountRateEnabled = _useFeatureToggle[FT_PI_DISCOUNT_RATE],
    isBarrierFreeLabelEnabledFT = _useFeatureToggle[FT_PI_BB_CCUI_BARRIER_FREE_LABEL];
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(['', '']),
    _useState4 = _slicedToArray(_useState3, 2),
    errorCode = _useState4[0],
    setErrorCode = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    searchConsoleIsActive = _useState6[0],
    setSearchConsoleIsActive = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    searchSummaryActive = _useState8[0],
    setSearchSummaryActive = _useState8[1];
  var _useLocalStorage = useLocalStorage('StayDetailsState', STAY_DETAILS_STATE_INITIAL_VALUE),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    stayDetailsState = _useLocalStorage2[0],
    setStayDetailsState = _useLocalStorage2[1];
  var _useLocalStorage3 = useLocalStorage('DistanceFromSearch', DISTANCE_FROM_SEARCH_INITIAL_VALUE),
    _useLocalStorage4 = _slicedToArray(_useLocalStorage3, 2),
    setDistanceFromSearch = _useLocalStorage4[1];
  var _useLocalStorage5 = useLocalStorage('SearchReferrer', SEARCH_REFERRER_INITIAL_VALUE),
    _useLocalStorage6 = _slicedToArray(_useLocalStorage5, 2),
    setSearchReferrer = _useLocalStorage6[1];
  var router = useRouter();
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var isPriceFinderPage = pageName === PageName.PRICE_FINDER;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var screenSize = useScreenSize();
  var isLessThanSm = screenSize.isLessThanSm,
    isLessThanMd = screenSize.isLessThanMd,
    isLessThanLg = screenSize.isLessThanLg;
  var isBarrierFreeLabelEnabled = language === CountryCode.DE ? isBarrierFreeLabelEnabledFT : false;
  var placeholderDate = ARRyyyy && ARRmm && ARRdd && new Date(ARRyyyy, ARRmm - 1, ARRdd);
  var firstDefaultEndDate = placeholderDate && add(placeholderDate, {
    days: NIGHTS > 0 ? NIGHTS : 1
  }) || null;
  var firstDefaultStartDate = placeholderDate || null;
  var today = new Date();
  var tomorrow = add(today, {
    days: 1
  });
  var _useState9 = useState(firstDefaultStartDate),
    _useState0 = _slicedToArray(_useState9, 2),
    startDate = _useState0[0],
    setStartDate = _useState0[1];
  var _useState1 = useState(firstDefaultEndDate),
    _useState10 = _slicedToArray(_useState1, 2),
    endDate = _useState10[0],
    setEndDate = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isNumberOfNightsError = _useState12[0],
    setIsNumberOfNightsError = _useState12[1];
  var errorKey = ['', ''];
  var URL = router.asPath;
  var _errorCode = _slicedToArray(errorCode, 2),
    validationKey = _errorCode[0],
    validationField = _errorCode[1];
  var isDatepickerError = validationField === FIELDS.datepicker;
  var query = getStaticContent(isBarrierFreeLabelEnabled);
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], query, {
      country,
      language,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    isLoadingTranslations = _useQueryRequest.isLoading,
    isErrorTranslations = _useQueryRequest.isError,
    dataTranslations = _useQueryRequest.data,
    errorTranslations = _useQueryRequest.error;
  var _useQueryRequest2 = useQueryRequest(['getSearchRules', Channel.Pi], GET_SEARCH_RULES_QUERY, {
      channel: Channel.Pi
    }),
    isLoadingSearchRules = _useQueryRequest2.isLoading,
    isErrorSearchRules = _useQueryRequest2.isError,
    dataSearchRules = _useQueryRequest2.data,
    errorSearchRules = _useQueryRequest2.error;
  var isNumberOfNightsUrlError = Number(NIGHTS) < 1 || !NIGHTS || NIGHTS > (dataSearchRules === null || dataSearchRules === void 0 || (_maxNightsLimitation = dataSearchRules.maxNightsLimitation) === null || _maxNightsLimitation === void 0 ? void 0 : _maxNightsLimitation.maxNights);
  useEffect(() => {
    if (defaultLocation) {
      handleLocationInputChange(defaultLocation);
    }
  }, []);
  useEffect(() => {
    if (typeof isSummaryActive === 'boolean') {
      setSearchSummaryActive(isSummaryActive);
    }
  }, [isSummaryActive, defaultLocation, defaultLocation, searchLocation]);
  useEffect(() => {
    if (router.asPath !== URL && !isPriceFinderPage) {
      router.push("/".concat(country).concat(URL), undefined, {
        shallow: true
      });
    }
    if (errorKey) {
      var _errorKey = errorKey,
        _errorKey2 = _slicedToArray(_errorKey, 2),
        _key = _errorKey2[0],
        field = _errorKey2[1];
      var _errorCode2 = _slicedToArray(errorCode, 1),
        currentKey = _errorCode2[0];
      if (_key !== currentKey && _key !== undefined && field !== undefined) {
        setErrorCode([_key, field]);
      }
    }
  });
  useEffect(() => {
    var _errorCode3 = _slicedToArray(errorCode, 2),
      key = _errorCode3[0],
      field = _errorCode3[1];
    if (key && field) {
      setSearchSummaryActive(false);
      setSearchConsoleIsActive(true);
    }
  }, [errorCode]);
  useEffect(() => {
    if (isDatepickerError) {
      setStartDate(null);
      setEndDate(null);
    }
    if (isNumberOfNightsUrlError) {
      setIsNumberOfNightsError(true);
      setStartDate(today);
      setEndDate(tomorrow);
    }
  }, [isDatepickerError]);
  var offers = (dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea = dataTranslations.headerInformation) === null || _dataTranslations$hea === void 0 || (_dataTranslations$hea = _dataTranslations$hea.content) === null || _dataTranslations$hea === void 0 || (_dataTranslations$hea = _dataTranslations$hea.global) === null || _dataTranslations$hea === void 0 ? void 0 : _dataTranslations$hea.offers) || [];
  var promotions = (dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea2 = dataTranslations.headerInformation) === null || _dataTranslations$hea2 === void 0 || (_dataTranslations$hea2 = _dataTranslations$hea2.content) === null || _dataTranslations$hea2 === void 0 || (_dataTranslations$hea2 = _dataTranslations$hea2.global) === null || _dataTranslations$hea2 === void 0 ? void 0 : _dataTranslations$hea2.promotions) || [];
  var _useOfferDetection = useOfferDetection(offers, promotions),
    cellCodes = _useOfferDetection.cellCodes,
    corpId = _useOfferDetection.corpId,
    promoId = _useOfferDetection.promoId,
    matchedOffer = _useOfferDetection.matchedOffer,
    hasActiveMatch = _useOfferDetection.hasActiveMatch;
  var isSearchLoading = isLoadingSearchRules || isLoadingTranslations;
  if (isSearchLoading) {
    return _jsx(Text, {
      "data-testid": "loading-message",
      style: {
        display: 'none'
      },
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isErrorSearchRules) {
    return _jsx(Text, {
      "data-testid": "error-search-rules-message",
      children: errorSearchRules.message
    });
  }
  if (isErrorTranslations) {
    return _jsx(Text, {
      "data-testid": "error-translations-message",
      children: errorTranslations.message
    });
  }
  var partialTranslations = (dataTranslations === null || dataTranslations === void 0 ? void 0 : dataTranslations.headerInformation) || {};
  var roomCodes = (dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea3 = dataTranslations.headerInformation) === null || _dataTranslations$hea3 === void 0 || (_dataTranslations$hea3 = _dataTranslations$hea3.config) === null || _dataTranslations$hea3 === void 0 ? void 0 : _dataTranslations$hea3.roomCodes) || {};
  var globalTranslations = (partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$ = partialTranslations.content) === null || _partialTranslations$ === void 0 ? void 0 : _partialTranslations$.global) || {};
  var globalMaxRooms = dataSearchRules === null || dataSearchRules === void 0 || (_globalConfig = dataSearchRules.globalConfig) === null || _globalConfig === void 0 || (_globalConfig = _globalConfig.maxRoomsLim) === null || _globalConfig === void 0 ? void 0 : _globalConfig.maxRooms;
  var globalMaxNights = dataSearchRules === null || dataSearchRules === void 0 || (_maxNightsLimitation2 = dataSearchRules.maxNightsLimitation) === null || _maxNightsLimitation2 === void 0 ? void 0 : _maxNightsLimitation2.maxNights;
  var maxRooms = (_matchedOffer$maxRoom = matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.maxRooms) !== null && _matchedOffer$maxRoom !== void 0 ? _matchedOffer$maxRoom : globalMaxRooms;
  var maxNights = (_matchedOffer$numberO = matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.numberOfNights) !== null && _matchedOffer$numberO !== void 0 ? _matchedOffer$numberO : globalMaxNights;
  var validateSearchDataResults = validateSearchData(Number(ARRdd), Number(ARRmm), Number(ARRyyyy), Number(NIGHTS), items, dataTranslations, router, dataSearchRules === null || dataSearchRules === void 0 || (_maxArrivalDateLimita = dataSearchRules.maxArrivalDateLimitation) === null || _maxArrivalDateLimita === void 0 ? void 0 : _maxArrivalDateLimita.maxArrivalDate, maxNights, defaultRooms, false, maxRooms, undefined, isPriceFinderPage);
  errorKey = validateSearchDataResults.errorKey;
  URL = validateSearchDataResults.url;
  var swappedRoomCodes = swapKeysAndValues(roomCodes);
  var AEMTranslations = {
    adultsLabel: t('dashboard.bookings.adults'),
    childrenLabel: t('dashboard.bookings.children'),
    roomTypeLabel: t('search.roomType'),
    locationPlaceholder: t('hoteldetails.location'),
    submitButtonLabel: t('search.submit.search'),
    datepickerCheckinLabel: t('account.dashboard.checkin.text'),
    datepickerCheckoutLabel: t('account.dashboard.checkout.text'),
    datepickerInvalidDates: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$2 = partialTranslations.datePicker) === null || _partialTranslations$2 === void 0 ? void 0 : _partialTranslations$2.invalidDate,
    priceFinderLocationPlaceholder: t('priceFinder.searchBar.location.placeholder'),
    accessibleRoom: t('priceFinder.roomType.DIS')
  };
  var errorMessages = {
    ["".concat(ERROR_KEYS.invalidLocation)]: isPriceFinderPage ? t('priceFinder.searchBar.location.error') : t('error.blank.location'),
    ["".concat(ERROR_KEYS.invalidDate)]: isNumberOfNightsError ? dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea4 = dataTranslations.headerInformation) === null || _dataTranslations$hea4 === void 0 || (_dataTranslations$hea4 = _dataTranslations$hea4.form) === null || _dataTranslations$hea4 === void 0 ? void 0 : _dataTranslations$hea4.invalidNights : dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea5 = dataTranslations.headerInformation) === null || _dataTranslations$hea5 === void 0 || (_dataTranslations$hea5 = _dataTranslations$hea5.form) === null || _dataTranslations$hea5 === void 0 ? void 0 : _dataTranslations$hea5.invalidDate,
    ["".concat(ERROR_KEYS.arrivalDateInThePast)]: dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea6 = dataTranslations.headerInformation) === null || _dataTranslations$hea6 === void 0 || (_dataTranslations$hea6 = _dataTranslations$hea6.form) === null || _dataTranslations$hea6 === void 0 ? void 0 : _dataTranslations$hea6.invalidPastDate,
    ["".concat(ERROR_KEYS.arrivalDateInTheFuture)]: dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea7 = dataTranslations.headerInformation) === null || _dataTranslations$hea7 === void 0 || (_dataTranslations$hea7 = _dataTranslations$hea7.form) === null || _dataTranslations$hea7 === void 0 ? void 0 : _dataTranslations$hea7.invalidFutureDate,
    ["".concat(ERROR_KEYS.invalidNights)]: dataTranslations === null || dataTranslations === void 0 || (_dataTranslations$hea8 = dataTranslations.headerInformation) === null || _dataTranslations$hea8 === void 0 || (_dataTranslations$hea8 = _dataTranslations$hea8.form) === null || _dataTranslations$hea8 === void 0 ? void 0 : _dataTranslations$hea8.invalidNights,
    ["".concat(ERROR_KEYS.invalidOccupancy)]: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$3 = partialTranslations.form) === null || _partialTranslations$3 === void 0 ? void 0 : _partialTranslations$3.invalidRooms
  };
  var mappedRoomLabels = getMappedRooms(roomCodes, globalTranslations, isBarrierFreeLabelEnabled);
  var message = validationKey && errorMessages[validationKey];
  var searchStyles = getSearchStyles(logicalAndOperator(validationKey !== '', validationKey !== undefined), language);
  var searchPriceFinderStyles = getSearchPriceFinderStyles();
  var searchConsoleActiveHandler = value => {
    setSearchConsoleIsActive(value);
  };
  var translationDateLanguage = {
    locale: ternaryCondition(language === 'en', enGB, de)
  };
  var isMissingDate = !ARRdd || !ARRmm || !ARRyyyy || !NIGHTS;
  function getSummaryDateInterval() {
    if (isMissingDate) {
      var _partialTranslations$4, _partialTranslations$5;
      return "".concat(partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$4 = partialTranslations.content) === null || _partialTranslations$4 === void 0 || (_partialTranslations$4 = _partialTranslations$4.global) === null || _partialTranslations$4 === void 0 ? void 0 : _partialTranslations$4.today, " | ").concat(partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$5 = partialTranslations.content) === null || _partialTranslations$5 === void 0 || (_partialTranslations$5 = _partialTranslations$5.global) === null || _partialTranslations$5 === void 0 ? void 0 : _partialTranslations$5.tomorrow);
    }
    if (isValid(startDate)) {
      if (!isLessThanSm) {
        return formatSummaryDateRange('dd MMM', startDate, endDate, translationDateLanguage);
      }
      return formatSummaryDateRange('EEE dd MMM', startDate, endDate, translationDateLanguage);
    }
  }
  var searchSummaryProps = searchSummaryActive ? {
    handleEdit: setSearchSummaryActive,
    isSummaryActive: searchSummaryActive,
    location: defaultLocation,
    dateInterval: getSummaryDateInterval(),
    roomSummary: getRoomsPlaceholder(defaultRooms, {
      adult: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$6 = partialTranslations.content) === null || _partialTranslations$6 === void 0 || (_partialTranslations$6 = _partialTranslations$6.global) === null || _partialTranslations$6 === void 0 ? void 0 : _partialTranslations$6.adult,
      adults: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$7 = partialTranslations.content) === null || _partialTranslations$7 === void 0 || (_partialTranslations$7 = _partialTranslations$7.global) === null || _partialTranslations$7 === void 0 ? void 0 : _partialTranslations$7.adults,
      child: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$8 = partialTranslations.content) === null || _partialTranslations$8 === void 0 || (_partialTranslations$8 = _partialTranslations$8.global) === null || _partialTranslations$8 === void 0 ? void 0 : _partialTranslations$8.child,
      children: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$9 = partialTranslations.content) === null || _partialTranslations$9 === void 0 || (_partialTranslations$9 = _partialTranslations$9.global) === null || _partialTranslations$9 === void 0 ? void 0 : _partialTranslations$9.children,
      room: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$0 = partialTranslations.content) === null || _partialTranslations$0 === void 0 || (_partialTranslations$0 = _partialTranslations$0.global) === null || _partialTranslations$0 === void 0 ? void 0 : _partialTranslations$0.room,
      rooms: partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$1 = partialTranslations.content) === null || _partialTranslations$1 === void 0 || (_partialTranslations$1 = _partialTranslations$1.global) === null || _partialTranslations$1 === void 0 ? void 0 : _partialTranslations$1.rooms
    }),
    editText: t('amend.edit'),
    isLessThanSm,
    isLessThanMd,
    isLessThanLg
  } : {};
  var suggestions = items || initialData;
  return _jsxs(_Fragment, {
    children: [isPriceFinderPage && _jsx(SearchPriceFinder, {
      locale: language,
      onLocationInputChange: debounce(handleLocationInputChange, 300),
      onLocationInputClear: handleLocationInputClear,
      onLocationInputFocus: handleLocationInputFocus,
      onIsSearchActive: searchConsoleActiveHandler,
      suggestions: suggestions,
      errorField: validationField,
      errorMessage: message,
      isSearchActive: searchConsoleIsActive,
      router: router,
      searchLocation,
      partialTranslations,
      AEMTranslations,
      handleButtonClick,
      screenSize,
      defaultLocation,
      marginBottom,
      searchPriceFinderStyles,
      handleLocationSearch,
      setLocationName
    }, router.asPath), !isPriceFinderPage && (!searchSummaryActive ? _jsx(Search, {
      locale: language,
      onLocationInputChange: debounce(handleLocationInputChange, 300),
      onLocationInputClear: handleLocationInputClear,
      onLocationInputFocus: handleLocationInputFocus,
      onIsSearchActive: searchConsoleActiveHandler,
      onSelectDates: handleSelectDates,
      onOccupancyChange: handleRoomOccupancyChange,
      suggestions: suggestions,
      roomCodes: swappedRoomCodes,
      errorField: validationField,
      errorMessage: message,
      isSearchActive: searchConsoleIsActive,
      mappedRoomLabels: swapKeysAndValues(mappedRoomLabels),
      isPIGroupBookingFormEnabled: isPIGroupBookingFormEnabled,
      isDiscountRateEnabled: isDiscountRateEnabled,
      isBarrierFreeLabelEnabled: isBarrierFreeLabelEnabled,
      searchLocation,
      ARRdd,
      ARRmm,
      ARRyyyy,
      ROOMS,
      NIGHTS,
      dataStayRules: dataSearchRules,
      dataRoomOccupancyLimitations: dataSearchRules,
      partialTranslations,
      AEMTranslations,
      screenSize,
      handleButtonClick,
      searchStyles,
      defaultLocation,
      defaultRooms,
      startDate,
      endDate,
      isDatepickerError,
      isActiveMatchedOffer: hasActiveMatch,
      matchedOffer: matchedOffer !== null && matchedOffer !== void 0 ? matchedOffer : undefined,
      marginBottom,
      disableFlip
    }, router.asPath) : _jsx(SearchSummary, _objectSpread(_objectSpread({}, searchSummaryProps), {}, {
      style: {
        containerStyle: {
          borderRadius: {
            mobile: '0',
            sm: '50px'
          }
        }
      }
    })))]
  });
  function getSuggestions(_x) {
    return _getSuggestions.apply(this, arguments);
  }
  function _getSuggestions() {
    _getSuggestions = _asyncToGenerator(function* (value) {
      var response = yield fetch("".concat(publicRuntimeConfig.NEXT_PUBLIC_SNOWDROP_BASE_URL, "v1/autocomplete?input=/").concat(value, "&gplaces[components]=country:uk|country:de"));
      return response.json();
    });
    return _getSuggestions.apply(this, arguments);
  }
  function handleLocationInputChange(value) {
    if (value && value.trim().length >= MIN_LENGTH_SEARCH_TERM) {
      getSuggestions(value).then(data => {
        setItems(data);
        if (validationField === FIELDS.location) {
          setErrorCode([undefined, undefined]);
        }
      });
    } else {
      setItems(null);
    }
  }
  function handleLocationInputClear() {
    setItems(null);
    if (validationField === FIELDS.location) {
      setErrorCode([undefined, undefined]);
    }
  }
  function handleLocationInputFocus(searchTerm) {
    if ((searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.length) === 0) {
      if (validationField === FIELDS.location) {
        setErrorCode([undefined, undefined]);
      }
      setItems(null);
    }
  }
  function handleButtonClick(_x2) {
    return _handleButtonClick.apply(this, arguments);
  }
  function _handleButtonClick() {
    _handleButtonClick = _asyncToGenerator(function* (queryParams) {
      var _queryParams$rooms;
      if (!(queryParams !== null && queryParams !== void 0 && queryParams.searchTerm)) {
        setErrorCode([ERROR_KEYS.invalidLocation, ERROR_FIELDS.invalidLocation]);
        return;
      }
      var stayDetailsInfo = setSearchLocationInLocalStorage(queryParams, stayDetailsState);
      setStayDetailsState(stayDetailsState => {
        stayDetailsState.data.info = stayDetailsInfo;
        return stayDetailsState;
      });
      var referrer = {
        data: {
          referrer: router.asPath
        }
      };
      setSearchReferrer(referrer);
      setDistanceFromSearch(DISTANCE_FROM_SEARCH_INITIAL_VALUE);
      var paramsMappedForURL = mapSearchParamsForURL(queryParams);
      var roomOccupancyParamsForURL = queryParams === null || queryParams === void 0 || (_queryParams$rooms = queryParams.rooms) === null || _queryParams$rooms === void 0 ? void 0 : _queryParams$rooms.filter(room => room.roomType).map((room, idx) => "ADULT".concat(idx + 1, "=").concat(room.adults, "&CHILD").concat(idx + 1, "=").concat(room.children, "&COT").concat(idx + 1, "=").concat(room.shouldIncludeCot ? 1 : 0, "&INTTYP").concat(idx + 1, "=").concat(room.roomType && mappedRoomLabels[room.roomType])).join('&');
      var URLToRedirect = "ARRdd=".concat(paramsMappedForURL.ARRdd, "&ARRmm=").concat(paramsMappedForURL.ARRmm, "&ARRyyyy=").concat(paramsMappedForURL.ARRyyyy, "&NIGHTS=").concat(paramsMappedForURL.nights, "&ROOMS=").concat(paramsMappedForURL.roomsNumber, "&").concat(roomOccupancyParamsForURL);
      if (cellCodes) {
        URLToRedirect += "&CELLCODES=".concat(cellCodes);
      }
      if (corpId || CORPID) {
        URLToRedirect += "&CORPID=".concat(corpId || CORPID);
      }
      if (promoId || PROMOID) {
        URLToRedirect += "&PROMOID=".concat(promoId || PROMOID);
      }
      var singleHotelSearchLabels = {
        bookingChannel: partialTranslations.config.api.bookingChannel.leisure,
        mappedRoomLabels: mappedRoomLabels
      };
      window.location = yield singleHotelSearchBB(stayDetailsState, paramsMappedForURL, singleHotelSearchLabels, URLToRedirect, queryParams, country, language, BOOKING_CHANNEL.PI, variant);
    });
    return _handleButtonClick.apply(this, arguments);
  }
  function handleSelectDates(dates) {
    var _ref3 = dates,
      _ref4 = _slicedToArray(_ref3, 2),
      start = _ref4[0],
      end = _ref4[1];
    setStartDate(start);
    setEndDate(end);
    if (validationField === FIELDS.datepicker || validationField === FIELDS.numberOfNights) {
      setErrorCode([undefined, undefined]);
    }
  }
  function handleRoomOccupancyChange() {
    if (validationField === FIELDS.occupancy) {
      setErrorCode([undefined, undefined]);
    }
  }
}